<script>
  import { onMount } from "svelte";
  import { validate_each_argument } from "svelte/internal";
  import App from "./App.svelte";
  import Blog from "./Blog.svelte";
  import CardList from "./CardList.svelte";
  import Note from "./Note.svelte";
  // export let productMasterOrganized;
  export let organizeProductMaster;
  export let productMap;

  /*
   * document.querySelectorの省略
   * target {HTMLElement}
   */
  const qs = (target) => {
    return document.querySelector(target);
  };
  const toggleExpand = () => {
    const elms = {
      submenu: qs(".js_submenu_list"),
      btn: qs(".js_subMenuBtn"),
      overlay: qs(".js_submenu_overlay"),
      body: qs("body"),
    };
    if (elms.submenu.getAttribute("aria-expanded") === "false") {
      //Object.entriesでオブジェクトを配列化
      for (const el of Object.entries(elms)) {
        el[1].setAttribute("aria-expanded", "true");
      }
      return false;
    } else {
      for (const el of Object.entries(elms)) {
        el[1].setAttribute("aria-expanded", "false");
      }
    }
  };

  const closeSubMenu = () => {
    const elms = {
      submenu: qs(".js_submenu_list"),
      btn: qs(".js_subMenuBtn"),
      overlay: qs(".js_submenu_overlay"),
      body: qs("body"),
    };
    for (const el of Object.entries(elms)) {
      el[1].setAttribute("aria-expanded", "false");
    }
  };
</script>

{#await organizeProductMaster() then response}
  <button on:click={toggleExpand} class="js_subMenuBtn" aria-expanded="false">
    <p>カードパック一覧</p>
    <img src={`/images/arrow_button.svg`} class="arrow" alt="" />
  </button>

  <div class="js_submenu_overlay" aria-expanded="false" />
  <ul class="js_submenu_list" aria-expanded="false">
    {#each [...productMap] as [key, value], index}
      {#if value.length > 0}
        <li><a href={`#scrollTarget${index}`} on:click={closeSubMenu}>{key}</a></li>
      {/if}
    {/each}
  </ul>
{/await}
